export default function formatAge(age) {
  const yearFraction = age % 1;

  if (yearFraction === 0) {
    return `${age} years`;
  }

  const nearestMonth = Math.round(yearFraction * 12);
  return `${Math.floor(age)} years and ${nearestMonth} ${
    nearestMonth === 1 ? 'month' : 'months'
  }`;
}
